
const EngagementCarouselSection = ({ children, className = '', ...rest }) => {
  return (
    <section
      className={[
        'bg-white/95 backdrop-blur-md rounded-2xl shadow-sm',
        'p-3 sm:p-4 md:p-5 overflow-hidden',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </section>
  );
};

export default EngagementCarouselSection;
